import { render } from "./PagamentoBoletoCartao.vue?vue&type=template&id=c85abf44"
import script from "./PagamentoBoletoCartao.vue?vue&type=script&lang=js"
export * from "./PagamentoBoletoCartao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__